module.exports = __webpack_public_path__ + "c9dc7e4d58cb37da3544b73e163bdf49.svg";